import {Component, Vue} from 'vue-property-decorator';
import {TableHeader} from '@/model/CommonModel';

@Component
export default class SelectDialogMixin extends Vue {
    protected readonly DEFAULT_WIDTH: string = '1000px';
    protected width: string = this.DEFAULT_WIDTH;
    protected visible: boolean = false;
    protected maxLength: number = Infinity;
    protected keyword: string = '';
    protected lastKeyword: string = '';
    
    get tableBodyHeight() {
        return '300px';
    }
    
    get isVisible() {
        return this.visible;
    }
    
    get getWidth() {
        return this.width;
    }
    
    get leftStyle() {
        return {width: `${this.leftWidth}%`};
    }
    
    get rightStyle() {
        return {'width': `${100 - this.leftWidth}%`};
    }
    
    get leftWidth() {
        return 70;
    }
    
    get isKeywordMaxlengthExceed() {
        return this.keyword?.length > this.maxLength;
    }
    
    get getAlert() {
        return this.isKeywordMaxlengthExceed
            ? this.$t('message.case.dialog.directInputMaxlengthExceed').toString()
            : this.$t('message.case.dialog.alert').toString();
    }
    
    protected afterOpened() {
        const keyword = this.$refs.keyword as any;
        if (keyword && keyword.focus) {
            keyword.focus();
        }
    }
    
    protected onNavigate(params: any) {
        const {pageNo, rowCount} = params;
        this.retrieve(pageNo, rowCount);
    }
    
    protected onSearch() {
        this.retrieve(1, 10);
    }
    
    protected retrieve(pageNo: number, rowCount: number) {
    
    }
    
    /**
     * Select dialog 내에선 별도의 필터링, 정렬을 컬럼 수준에서 지원하지 않기 때문에 아래와 같이 가공 작업을 진행한다.
     * @param columns 조회 된 컬럼 목록
     * @return 필터 종류, 필터 여부, 정렬 여부가 초기화 된 컬럼 목록
     */
    protected initializeColumns(columns: TableHeader[]): TableHeader[] {
        columns.forEach((column: TableHeader) => {
            column.filterType = 'NONE';
            column.filtered = 'N';
            column.sorted = 'N';
        });
        return columns;
    }
}
